export default __webpack_public_path__ + "buysearchsell/images/adults_heels.svg";